// Utility functions for date formatting

/**
 * Converte una data dal formato YYYY-MM-DD a GG/MM/AAAA
 * @param {string} dateStr - Data in formato ISO (YYYY-MM-DD)
 * @returns {string} Data in formato italiano (GG/MM/AAAA)
 */
export const formatDateIT = (dateStr) => {
  if (!dateStr) return '';
  
  // Se è già nel formato GG/MM/AAAA, ritorna così com'è
  if (dateStr.includes('/')) return dateStr;
  
  // Se è in formato ISO YYYY-MM-DD
  const parts = dateStr.split('-');
  if (parts.length === 3) {
    return `${parts[2]}/${parts[1]}/${parts[0]}`;
  }
  
  return dateStr;
};

/**
 * Converte una data dal formato GG/MM/AAAA a YYYY-MM-DD
 * @param {string} dateStr - Data in formato italiano (GG/MM/AAAA)
 * @returns {string} Data in formato ISO (YYYY-MM-DD)
 */
export const formatDateISO = (dateStr) => {
  if (!dateStr) return '';
  
  // Se è già nel formato YYYY-MM-DD, ritorna così com'è
  if (dateStr.includes('-')) return dateStr;
  
  // Se è in formato GG/MM/AAAA
  const parts = dateStr.split('/');
  if (parts.length === 3) {
    return `${parts[2]}-${parts[1]}-${parts[0]}`;
  }
  
  return dateStr;
};

/**
 * Formatta un range di date per rapporti multigiorno
 * @param {string} startDate - Data inizio in formato ISO
 * @param {string} endDate - Data fine in formato ISO
 * @returns {string} Range formattato (es. "dal 01/01/2026 al 05/01/2026")
 */
export const formatDateRange = (startDate, endDate) => {
  return `dal ${formatDateIT(startDate)} al ${formatDateIT(endDate)}`;
};
